/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PrintMail {
    NONE = 'None',
    THIRD_PARTY = 'ThirdParty',
    POS = 'POS',
}